"use strict";
/**
 * Lead Source Constant
 *
 * Identifies where a loan application originated and where its most recent
 * status transition was made. Written into the `lead_source` field as
 * `{ initiated, updated }` — `initiated` is set at document creation, `updated`
 * is set on the AWAIT status transition. Mirrors the `sources` field structure.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LEAD_SOURCE = void 0;
exports.LEAD_SOURCE = "sky_web_botswana";
